import { ReactNode, ComponentType } from "react";
import {
  ACCOUNT_ROUTE,
  ADMIN_EVENTS_ROUTE,
  ADMIN_WITHDRAWALS_ROUTE,
  ADMIN_ROUTE,
  ADMIN_USERS_ROUTE,
  ADMIN_SUBSCRIPTIONS_ROUTE,
  ADMIN_ORDERS_ROUTE,
  ADMIN_CHATS_ROUTE,
  ADMIN_CHAT_SETTINGS_ROUTE,
  ADMIN_FEES_ROUTE,
  ADMIN_ADVERTISING_ROUTE,
  ADMIN_QUOTES_ROUTE,
  ADMIN_CRM_ROUTE,
  ADMIN_PROMOS_ROUTE,
  ADMIN_CHAT_REPORTS_ROUTE,
  ADMIN_BLOCKED_USERS_ROUTE,
  ADMIN_SETTINGS_ROUTE,
  CALENDAR_ROUTE,
  CHATS_ROUTE,
  EVENTS_ROUTE,
  FAQ_ROUTE,
  MY_EVENTS_ROUTE,
  PROFILE_ROUTE,
  SIGNOUT_ROUTE,
  FOLLOWERS_ROUTE,
} from "./routes";
import { ShieldCheckIcon } from "lucide-react";
import {
  QuestionMarkCircleIcon,
  HomeIcon,
  UsersIcon,
  CalendarDaysIcon,
  CreditCardIcon,
  ChatBubbleLeftRightIcon,
  BanknotesIcon,
  CurrencyDollarIcon,
  MegaphoneIcon,
  ChatBubbleBottomCenterTextIcon,
  ClipboardDocumentListIcon,
  TagIcon,
  FlagIcon,
  NoSymbolIcon,
  SparklesIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";

export const APP_NAME = "GioJoy";
export const LOGO_URL = `${process.env.PUBLIC_URL}/logo192.png`;
export const WORDMARK_URL = `${process.env.PUBLIC_URL}/giojoy-wordmark.png`;
export const SHARE_URL = `https://share.giojoy.com`;

export const userRoleAdmin = "admin";
export const userRoleAssociate = "associate";
export const userRoleHost = "host";

export type NavigationItem = {
  name: ReactNode;
  href: string;
  public: boolean;
  roles?: string[]; // Optional array of roles
  icon?: ComponentType<any>; // Optional icon component
};

// Admin-specific navigation item (no `public` field)
export type AdminNavigationItem = {
  name: ReactNode;
  href: string;
  roles?: string[];
  icon?: ComponentType<any>;
};

export type UserNavigationItem = {
  name: ReactNode;
  href: string;
  roles?: string[]; // Optional array of roles
};

export const publicNavigation: NavigationItem[] = [
  { name: "Eventi", href: EVENTS_ROUTE, public: true },
  { name: "Calendario", href: CALENDAR_ROUTE, public: true },
  {
    name: 
        "Chat"
    ,
    href: CHATS_ROUTE,
    public: false,
  },
  {
    name: (
      <div className="flex items-center">
        <QuestionMarkCircleIcon className="mr-1.5 h-7 w-7 stroke-2 " /> Aiuto
      </div>
    ),
    href: FAQ_ROUTE,
    public: false,
  },
];

export const userNavigation = [
  { name: "Profilo", href: PROFILE_ROUTE },
  { name: "Account", href: ACCOUNT_ROUTE },
  { name: "Followers", href: FOLLOWERS_ROUTE },
  { name: "I miei eventi", href: MY_EVENTS_ROUTE },
  {
    name: (
      <div className="flex items-center font-bold">
        Admin
        <ShieldCheckIcon className="ml-1.5 h-4 w-4 text-orange-500" />
      </div>
    ),
    href: ADMIN_ROUTE,
    roles: [userRoleAdmin],
  },
  { name: "Esci", href: SIGNOUT_ROUTE },
];

export const adminNavigation: AdminNavigationItem[] = [
  { name: "Dashboard", href: ADMIN_ROUTE, icon: HomeIcon },
  { name: "Utenti", href: ADMIN_USERS_ROUTE, icon: UsersIcon },
  { name: "Eventi", href: ADMIN_EVENTS_ROUTE, icon: CalendarDaysIcon },
  { name: "Chat", href: ADMIN_CHATS_ROUTE, icon: ChatBubbleLeftRightIcon },
  { name: "Assistente GioJoy", href: ADMIN_CHAT_SETTINGS_ROUTE, icon: SparklesIcon },
  { name: "Ordini", href: ADMIN_ORDERS_ROUTE, icon: ClipboardDocumentListIcon },
  { name: "Commissioni", href: ADMIN_FEES_ROUTE, icon: BanknotesIcon },
  { name: "Prelievi", href: ADMIN_WITHDRAWALS_ROUTE, icon: CurrencyDollarIcon },
  { name: "Pubblicità", href: ADMIN_ADVERTISING_ROUTE, icon: MegaphoneIcon },
  { name: "Citazioni", href: ADMIN_QUOTES_ROUTE, icon: ChatBubbleBottomCenterTextIcon },
  { name: "Abbonamenti", href: ADMIN_SUBSCRIPTIONS_ROUTE, icon: CreditCardIcon },
  { name: "CRM", href: ADMIN_CRM_ROUTE, icon: MegaphoneIcon },
  { name: "Promo", href: ADMIN_PROMOS_ROUTE, icon: TagIcon },
  { name: "Segnalazioni", href: ADMIN_CHAT_REPORTS_ROUTE, icon: FlagIcon },
  { name: "Utenti bloccati", href: ADMIN_BLOCKED_USERS_ROUTE, icon: NoSymbolIcon },
  { name: "Impostazioni", href: ADMIN_SETTINGS_ROUTE, icon: Cog6ToothIcon },
];

export const cities = [
  { name: "Torino", latitude: 45.0703, longitude: 7.6869 },
  { name: "Milano", latitude: 45.4642, longitude: 9.19 },
  { name: "Roma", latitude: 41.9028, longitude: 12.4964 },
  { name: "Napoli", latitude: 40.8518, longitude: 14.2681 },
  { name: "Palermo", latitude: 38.1157, longitude: 13.3615 },
  { name: "Genova", latitude: 44.4056, longitude: 8.9463 },
  { name: "Bologna", latitude: 44.4949, longitude: 11.3426 },
  { name: "Firenze", latitude: 43.7696, longitude: 11.2558 },
  { name: "Bari", latitude: 41.1171, longitude: 16.8719 },
  { name: "Catania", latitude: 37.5079, longitude: 15.083 },
];

// Shared cache keys
export const SHAREDCACHE_ENABLE_CHAT_NOTIFICATIONS = "enableChatNotifications";
export const SHAREDCACHE_APP_ACTIVE = "app_active_state";
export const SHAREDCACHE_ACTIVE_CHAT = "active_chat_id";
